import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { getDecodedToken } from '../../utils/utils';
import axiosInstance from '../../api/axiosConfig';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { toast } from "react-toastify";
import { Global } from '../../Variables/Global';
import { first } from "lodash-es";

const ManageCompanies = () => {

    const [company, setCompanies] = useState();

    const [show, setShow] = useState(false);
    const [databaseName, setDatabaseName] = useState('');

    const [companyName, setCompanyName] = useState('');
    const [suffix, setSuffix] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userMobile, setUserMobile] = useState('');

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [submitDisabled, setSubmitDisabled] = useState(false);

    const handleSubmit = () => {
        setSubmitDisabled(true);

        const formData = new FormData();
        formData.append('databaseName', databaseName);
        formData.append('companyName', companyName);
        formData.append('suffix', suffix);
        formData.append('phone', phone);
        formData.append('email', email);
        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
        formData.append('userEmail', userEmail);
        formData.append('userMobile', userMobile);

        var config = {
            method: 'post',
            url: "Database/CreateDatabase",
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': Global.Host
            },
            data: formData
        };

        axiosInstance(config)
            .then(function (response) {
                if (response.status === 200) {
                    toast.success("Database Created")
                    handleClose();
                    GetCompanies();
                    setSubmitDisabled(false);
                }
            })
            .catch(function (error) {
                console.log(error);
                toast.error("Something Went Wrong")
                setSubmitDisabled(false);
            });
    }

    const handleDatabaseChange = (event) => {
        setDatabaseName(event.target.value);
    };

    const handleSuffixChange = (event) => {
        setSuffix(event.target.value);
    };

    const handleCompanyChange = (event) => {
        setCompanyName(event.target.value);
    };

    const handlePhoneChange = (event) => {
        setPhone(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };
    const handleFirstNameChange = (event) => {
        setFirstName(event.target.value);
    };
    const handleLastNameChange = (event) => {
        setLastName(event.target.value);
    };
    const handleUserEmailChange = (event) => {
        setUserEmail(event.target.value);
    };
    const handleUserMobileChange = (event) => {
        setUserMobile(event.target.value);
    };


    const columns = [
        {
            name: 'Company Name',
            selector: row => row.companyName,
        },
        {
            name: 'Phone',
            selector: row => row.phone,
        },
        {
            name: 'Email',
            selector: row => row.email,
        }
    ];
    const GetCompanies = () => {
        var config = {
            method: 'get',
            url: "Company/ManageCompanies",
            headers: {},
        };

        axiosInstance(config)
            .then(function (response) {
                setCompanies(response.data);
                console.log(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [permissions, setPermissions] = useState([])
    useEffect(() => {
        const decodedToken = getDecodedToken();
        const pJoin = JSON.stringify(JSON.parse(decodedToken.pJoin));
        var x = JSON.parse(pJoin);
        setPermissions(() => x);
        document.title = "Companies";
        GetCompanies();
        setUserMobile('');
    }, [])
    return (
        <>
            {permissions.viewCompany == false ? (
                <>
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h1>You Have No Permission</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </>) : (<>
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="page-title-box">
                                        <h4>Companies</h4>
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                            <li className="breadcrumb-item active">Companies</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className='row'>
                                                <div className='col-12 col-md-6'>
                                                    <h4 className="card-title">Companies</h4>
                                                </div>
                                                <div className='col-12 col-md-6 text-right'>
                                                    <button
                                                        onClick={() => {
                                                            setShow(true);
                                                            setDatabaseName('');
                                                            setCompanyName('');
                                                            setSuffix('');
                                                            setPhone('');
                                                            setEmail('');
                                                            setFirstName('');
                                                            setLastName('');
                                                            setUserEmail('');
                                                            setUserMobile('');

                                                        }}
                                                        className="btn btn-primary"
                                                    >
                                                        Add Company
                                                    </button>
                                                </div>
                                            </div>

                                            <DataTable
                                                columns={columns}
                                                data={company}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Modal for Adding Company */}
                        <Modal show={show} onHide={handleClose} centered>
                            <Modal.Header closeButton>
                                <Modal.Title>Enter Company Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Group controlId="formDatabaseName">
                                        <Form.Label>Database Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Database Name"
                                            value={databaseName}
                                            onChange={handleDatabaseChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid database name.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group controlId="formCompanyName" className="mt-3">
                                        <Form.Label>Company Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Company Name"
                                            value={companyName}
                                            onChange={handleCompanyChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid company name.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group controlId="formCompanySuffix" className="mt-3">
                                        <Form.Label>Company Suffix</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Company Suffix"
                                            value={suffix}
                                            onChange={handleSuffixChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid suffix.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group controlId="formPhoneNumber" className="mt-3">
                                        <Form.Label>Phone Number</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Phone Number"
                                            value={phone}
                                            onChange={handlePhoneChange}
                                            required
                                            pattern="^\d*$" // Ensures only digits are entered
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid phone number.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group controlId="formCompanyEmail" className="mt-3">
                                        <Form.Label>Company Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter Company Email"
                                            value={email}
                                            onChange={handleEmailChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid email address.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <br />
                                    {/* New Section for First Name, Last Name, and Email */}
                                    <div className="admin-user-details-section">
                                        <h2>Admin User Details</h2>
                                        <Row className="mt-4">
                                            <Col md={4}>
                                                <Form.Group controlId="formFirstName">
                                                    <Form.Label>First Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter First Name"
                                                        value={firstName}
                                                        onChange={handleFirstNameChange}
                                                        required
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide a valid first name.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="formLastName">
                                                    <Form.Label>Last Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Last Name"
                                                        value={lastName}
                                                        onChange={handleLastNameChange}
                                                        required
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide a valid last name.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="formUserMobile">
                                                    <Form.Label>Mobile</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Mobile"
                                                        value={userMobile}
                                                        onChange={handleUserMobileChange}
                                                        required
                                                        pattern="^\d*$" // Ensures only digits are entered
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide a valid mobile Number.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col md={12}>
                                                <Form.Group controlId="formEmail">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter Email"
                                                        value={userEmail}
                                                        onChange={handleUserEmailChange}
                                                        required
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide a valid email address.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button
                                    variant="primary"
                                    disabled={submitDisabled}
                                    onClick={handleSubmit}
                                >
                                    <i className="bi bi-save" style={{ marginRight: '8px' }}></i> Save
                                </Button>
                            </Modal.Footer>
                        </Modal>

                    </div>
                </>
            )}
        </>
    )
}
export default ManageCompanies